import { axios } from '@/plugins/http-axios';
import { Module } from 'vuex';
import { isDopDoc, isRequirementFile } from '@/components/Step3/constants';

export interface IDocument {
  allowTypes: string;
  description: string;
  digitalDocument: boolean;
  extraId: string;
  fileCount: number;
  fioPassport: null | string;
  id: number;
  maxFileSize: number;
  name: string;
  orderNum: number;
  required: boolean;
  type: string;
  files: IFile[];
  requirements: IRequirement[];
  isAttachedFile: boolean;
  isRequirements: boolean;
  requirementId: string;
  signatureType: boolean;
  idx: number;
  electronicDocument: boolean;
  electronicDocumentWithoutGeneration: boolean
  canDeleteDocumentThatHasNotPassedValidation: boolean
  documentTemplates: DocumentTeplate[]
  subType: string
}

export interface IMetaDataItem {
  id: string;
  name: string;
  type: string;
  defaultValue: string;
  value?: string;
}

export interface DocumentTeplate {
  id: string
  isDefault: boolean
  name: string
  templateName: string
}
interface IDocumentState {
  id: string;
  documents: IDocument[];
}

export interface IMetaBuilderContext {
  generateCfg: any; // TODO: Уточнить тип для generateTemplate
  appId: string;
  isSaveDisabled: boolean;
  fileId: string;
  requirementId: string;
  electronicWithoutGeneration: boolean
}

export interface IRequirement {
  artifactname: string;
  commentEmployee: string;
  completed: boolean;
  createDate: string;
  fileId: null | string;
  id: string;
  isAttachedFile: boolean;
}

export interface IResponseFile {
  id: string;
  name: string;
  createDate: string;
  validationDate: string | null;
  validated: null | boolean;
  origName: string;
  size: number;
  requirement: null | IRequirement;
  electroDocumentNumber: string | null;
  req: null | boolean;
  path: string
}

interface IconditionFile {
  id: string,
  name: string,
  createDate: string,
  origName: string,
  size: number,
  pathFile: string
}
export interface IFile extends IResponseFile {
  doctypeid: number
  templateId: string
  lkbExists: boolean
  availableForClient: boolean
  fileSelected: boolean
  dateFileSelected: string
  conditionFile?: IconditionFile
}

export interface IPayloadAddFileToReq {
  i: number;
  j: number;
  file: IFile;
}
export interface IPayloadAddFileToDoc {
  i: number;
  file: IFile;
}
export default <Module<IDocumentState, any>>{
  namespaced: true,
  state: {
    id: '',
    documents: [],
  },
  mutations: {
    setId(state, id: string = '') {
      state.id = id;
    },
    setDocs(state, docs: IDocument[]) {
      docs.forEach((doc, i) => {
        doc.idx= i;
        doc.allowTypes = '.' + doc.allowTypes.split(',').join(',.');
        doc.isRequirements = !!(doc.requirements.length && doc.files.length);

        if (doc.isRequirements) {
          //todo Исправить fileCount
          // doc.fileCountAbs = doc.fileCount + doc.requirements.length;
          doc.requirements = []; //Пересоздаём заново, чтобы появились ссылки
          doc.files.forEach((file) => {
            if (file.requirement && !file.requirement.completed) {
              file.requirement.isAttachedFile = false;
              doc.requirements.push(file.requirement); //Делаем ссылку
            }
          });
        } else {
          doc.isAttachedFile = !!doc.files.length;
        }
      });

      state.documents = docs;
    },
    setDigitalDoc(state, {i, number}:{i:number, number:string}) {
      const _doc = state.documents.find(item=>item.idx === i);
      if (_doc){
        const attach = !!number;
        _doc.isAttachedFile = !attach && !!_doc.files.length ? true : attach;
      }
    },
    setAttachedDoc(state, { i, val = false }: { i: number; val: boolean }) {
      state.documents[i].isAttachedFile = val;
    },
    removeFileFromDoc(state, { docIndex, fileId }) {
      const doc = state.documents[docIndex];
      if (doc && doc.files) {
        doc.files = doc.files.filter((file) => file.id !== fileId);
        if (doc.files.length === 0) {
          doc.isAttachedFile = false;
        }
        if (doc.isRequirements && doc.requirements) {
          doc.requirements = doc.requirements.filter((req) => req.fileId !== fileId);
        }
      }
    },
  },
  actions: {
    async getDocuments({ commit, dispatch, rootGetters }, id = rootGetters.appId): Promise<IDocument[]> {
      if (id) {
        const response = await axios.get<IDocument[]>(rootGetters.uri.documents(id))
        commit('setDocs', response.data);
        return response.data;
      } else {
        const e = new Error('Нет id');
        dispatch('setError', e, { root: true });
        return Promise.reject(e);
      }
    },
    async processingRequirements({ commit, dispatch, getters, rootGetters }): Promise<void> {
      if (rootGetters.appId != getters.oldId) {
        commit('setId', rootGetters.appId);
        await dispatch('getDocuments');
      }
      return Promise.resolve();
    },
  },
  getters: {
    docs: (state): IDocument[] => state.documents,
    documentsRequired: (state): IDocument[] => state.documents.filter((doc) => (doc.required || doc.isRequirements) && !doc.signatureType),
    documentsNotRequired: (state): IDocument[] =>
        state.documents.filter((doc) => !doc.required && !doc.isRequirements && !doc.signatureType),
    oldId: (state): string => state.id,
    isRequirementDoc:
        (state, getters, rootState, rootGetters) =>
            (doc: IDocument): boolean => {
              return (
                  /*doc.required && !doc.files.length ||*/ rootGetters.isAddDocs && (isDopDoc(doc)|| isRequirementFile(doc))
              );
            },
  },
};
